export default __webpack_public_path__ + "static/media/shop-03.5aa29e79.png";